import { createSlice } from '@reduxjs/toolkit'

import { initialState } from 'store/pages/wallet/state'

import { getEventTicketCodes } from '../actions/getEventTicketCodes'
import { getPastEvents } from '../actions/getPastEvents'
import { getPastGoodsServices } from '../actions/getPastGoodsServices'
import { getUpcomingEvents } from '../actions/getUpcomingEvents'
import { getUpcomingGoodsServices } from '../actions/getUpcomingGoodsServices'

export const WalletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    reset: () => {
      return { ...initialState }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPastEvents.fulfilled, (state, action) => {
      const { events, metadata } = action.payload
      const { currentPage, hasMorePages } = metadata

      state.events.past[currentPage] = events
      state.events.metadata.past.currentPage = currentPage
      state.events.metadata.past.hasMorePages = hasMorePages
    })
    builder.addCase(getUpcomingEvents.fulfilled, (state, action) => {
      const { events, metadata } = action.payload
      const { currentPage, hasMorePages } = metadata

      state.events.upcoming[currentPage] = events
      state.events.metadata.upcoming.currentPage = currentPage
      state.events.metadata.upcoming.hasMorePages = hasMorePages
    })
    builder.addCase(getEventTicketCodes.fulfilled, (state, action) => {
      const { items, metadata, eventIdOrCodeUrl } = action.payload

      if (!state.events.tickets.codes[eventIdOrCodeUrl]) {
        state.events.tickets.codes[eventIdOrCodeUrl] = {
          items: [],
          metadata,
        }
      }

      const uniqueCodes = [...state.events.tickets.codes[eventIdOrCodeUrl].items.concat(items).map((x) => x.cod)]

      state.events.tickets.codes[eventIdOrCodeUrl] = {
        items: uniqueCodes.map((x) => ({ cod: x })),
        metadata,
      }
    })
    builder.addCase(getPastGoodsServices.fulfilled, (state, action) => {
      const { goodsServices, metadata } = action.payload
      const { currentPage, hasMorePages } = metadata

      state.goodsServices.past[currentPage] = goodsServices
      state.goodsServices.metadata.past.currentPage = currentPage
      state.goodsServices.metadata.past.hasMorePages = hasMorePages
    })
    builder.addCase(getUpcomingGoodsServices.fulfilled, (state, action) => {
      const { goodsServices, metadata } = action.payload
      const { currentPage, hasMorePages } = metadata

      state.goodsServices.upcoming[currentPage] = goodsServices
      state.goodsServices.metadata.upcoming.currentPage = currentPage
      state.goodsServices.metadata.upcoming.hasMorePages = hasMorePages
    })
  },
})
